import classNames from 'classnames';
import React from 'react';
import { IString } from '../../../model';
import { SUMMARY_TOTAL_TEXT } from '../libs';
import { ITableColumn, ITableSummary, ITableSummaryKeys } from '../model';

interface IProps<T> {
  readonly columns: ReadonlyArray<ITableColumn<T>>;
  readonly data: ReadonlyArray<T>;
  readonly summary: ITableSummary<T>;
  readonly isRowSelection: boolean;
}

// 表尾合计
export function SummaryComponent<T>(props: IProps<T>) {
  const { data, summary } = props;
  const { summaryKeys } = summary;
  const sumText = props.summary.sumText || SUMMARY_TOTAL_TEXT;
  const align = props.summary.align || 'left';
  const getColumnTdSummaryValue = (key: string) => {
    let count = 0;
    /* eslint-disable */
    const len = data.length;
    for (let i = 0; i < data.length; i++) {
      const item: IString<any> = data[i];
      const numValue = Number(item[key]) || parseFloat(item[key]);
      if (typeof numValue !== 'number') {
        continue;
      }
      if (numValue !== numValue) {
        continue;
      }
      count = count + numValue;
    }
    return { count, avg: count / len };
  };

  const renderSummaryResult = (
    summaryKeys: IString<ITableSummaryKeys<T>>,
    item: ITableColumn<T>,
    index: number
  ) => {
    const summaryItem = summaryKeys[item.key];
    if (summaryItem) {
      const result = getColumnTdSummaryValue(item.key);
      const type = summaryItem.type || 'count';
      if (typeof summaryItem.getResult === 'string') {
        return `${type === 'count' ? result.count : result.avg}${
          summaryItem.getResult
        }`;
      }
      return summaryItem.getResult(result.count, result.avg, item, index);
    }
    return null;
  };

  const renderTd = () => {
    return props.columns.slice(1).map((item, index) => {
      if (item.colSpan === 0) {
        return null;
      }
      if (summaryKeys) {
        return (
          <td key={index} align={item.align}>
            {renderSummaryResult(summaryKeys, item, index)}
          </td>
        );
      }

      const result = getColumnTdSummaryValue(item.key);
      return (
        <td key={index} align={item.align}>
          {result.count}
        </td>
      );
    });
  };

  const renderTRSlot = (children: React.ReactNode) => {
    const className = classNames(
      'summary-row',
      props.summary.isSticky === false ? '' : 'sticky-summary'
    );
    return <tr className={className}>{children}</tr>;
  };

  if (props.summary.summaryMethod) {
    const summary = props.summary.summaryMethod(props.columns, props.data);
    return renderTRSlot(
      <>
        {summary.map((item, index: number) => {
          return (
            <td key={index} style={{ textAlign: align }}>
              {item}
            </td>
          );
        })}
      </>
    );
  }

  return renderTRSlot(
    <>
      <td key={-1} style={{ textAlign: align }}>
        {sumText}
      </td>
      {renderTd()}
      {props.isRowSelection ? <td></td> : null}
    </>
  );
}
